import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filter, includes } from 'lodash';
import { message } from 'antd';
import withModal from '../../../../lib/hoc/withModal';
import { widgetActions } from '../../../../store/modules/widget';
import { appActions } from '../../../../store/modules/app';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { comparePrePropsAndNextProps } from '../../../../lib/common';
import SearchHomeListModal from '../../../../views/widget/common/modal/SearchHomeListModal';

class SearchHomeModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedHomeList: [],
      selectedHomeIdList: props.data.selectedId ? [props.data.selectedId] : [],
    };
  }

  componentDidMount = () => {
    this.initiate(this.props.data.selectedId);
  };

  componentDidUpdate(prevProps) {
    if (comparePrePropsAndNextProps([[prevProps.data.selectedItem, this.props.data.selectedItem]])) {
      this.setState({
        selectedHomeList: [this.props.data.selectedItem],
      });
    }
  }

  initiate = (homeId) => {
    this.getList({
      homeId,
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  /**
   * 홈 페이지 선택하기
   */
  onSubmit = () => {
    const { selectedHomeList } = this.state;
    const { setData, data } = this.props;
    const { targetPath } = data;
    const selectedHome = selectedHomeList[0];

    /**
     *  홈 페이지가 선택되었는지 체크
     */
    if (!selectedHome) {
      message.error('서브 페이지를 선택해주세요.');
      return;
    }

    setData({
      path: [...targetPath, 'linkId'],
      value: selectedHome.id,
    });

    setData({
      path: [...targetPath, 'linkName'],
      value: selectedHome.title,
    });

    setData({
      path: [...targetPath, 'status'],
      value: selectedHome.status,
    });

    this.closeModal();
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'searchHomeListModal', value: false });
  };

  /**
   * 홈 리스트 가져오기
   */
  getList = (option) => {
    const { getHomeList, data } = this.props;
    const { listPath, listData } = data;
    const { filterOption, pagination } = listData;

    getHomeList({
      filterOption,
      pagination,
      ...option,
      listPath,
    });
  };

  /**
   * 홈 페이지 선택 callback
   */
  onCheckHome = (list) => {
    const { selectedHomeIdList } = this.state;
    const { data } = this.props;
    let targetIdList = list;

    if (list.length > 1) {
      targetIdList = filter(list, (id) => id !== selectedHomeIdList[0]);
    }

    const targetList = filter(data.listData.list, (item) => includes(targetIdList, item.id));

    this.setState({
      selectedHomeIdList: targetIdList,
      selectedHomeList: targetList,
    });
  };

  render() {
    return (
      <SearchHomeListModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
        getHomeList={this.getList}
        onCheckHome={this.onCheckHome}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.searchHomeListModal.isOpen,
    data: state.widget.searchHomeListModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: widgetActions.toggleModal,
  setData: widgetActions.setData,
  getHomeList: widgetActions.getModalSubPageList,
  openHomeItemListModal: appActions.openHomeItemListModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(SearchHomeModalContainer));
